import { DATASET_PROP } from '../consts';

/**
 * @type {import('./index').useDatasetPanel}
 */
export const useDatasetPanel =
    ({
         isMultiple = false,
         prop = DATASET_PROP,
         mixins = [],
         meta
     } = {}) =>
        () =>
            import('./DatasetPanel.vue').then(({ default: PanelOptions }) => ({
                default: {
                    ...PanelOptions,
                    meta: {
                        ...PanelOptions.meta,
                        ...meta
                    },
                    mixins: [
                        ...PanelOptions.mixins,
                        ...mixins
                    ],
                    static: {
                        ...PanelOptions.static,
                        DATASET_PROP: prop
                    },
                    props: {
                        ...PanelOptions.props,
                        isMultiple: {
                            type: Boolean,
                            default: isMultiple
                        }
                    }
                }
            }));

export const useDatasetVariablesPanel = () => [];

/**
 * @type {import('./index').useDatasetPanels}
 */
export const useDatasetPanels = ({
    isMultiple = false,
    prop = DATASET_PROP,
    mixins = [],
    meta
} = {}) => [useDatasetPanel({ isMultiple, prop, mixins, meta })];

export { default as DatasetPanel } from './DatasetPanel.vue';
export { default as DatasetRequestEditor } from './components/DatasetEditor.vue';
export { default as DatasetRequestManageMixin } from './mixins/DatasetRequestManageMixin';
export { default as DatasourceItem } from './components/datasource-panel/DatasourceItem.vue';

export const VariablePanelAsync = () => import('./VariablePanel.vue');
export const DeviationsPanelAsync = () => import('./DeviationsPanel.vue');
